export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_POLICY_HINT =
  'Mínimo 8 caracteres, com letras e números, ao menos 1 letra maiúscula e 1 caractere especial (ex.: ! @ # $ % & * ? _ -).';

const UPPERCASE_RE = /[A-Z]/;
const LOWERCASE_RE = /[a-z]/;
const NUMBER_RE = /[0-9]/;
const SPECIAL_RE = /[^A-Za-z0-9]/;

export function validatePasswordPolicy(password: string): string | null {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `A senha deve ter no mínimo ${PASSWORD_MIN_LENGTH} caracteres.`;
  }
  if (!UPPERCASE_RE.test(password)) {
    return 'A senha deve conter ao menos 1 letra maiúscula.';
  }
  if (!LOWERCASE_RE.test(password)) {
    return 'A senha deve conter ao menos 1 letra minúscula.';
  }
  if (!NUMBER_RE.test(password)) {
    return 'A senha deve conter ao menos 1 número.';
  }
  if (!SPECIAL_RE.test(password)) {
    return 'A senha deve conter ao menos 1 caractere especial (ex.: ! @ # $ % & * ? _ -).';
  }
  return null;
}
